import React, {Component} from 'react'
import AddTracksComponent from '../../components/addTracks'
import {getTracks, getGenres} from "../../logic/api";
import {database} from "../../logic/firebase";
import seededTracks from './seed'

export default class AddTracks extends Component {
    constructor(props) {
        super(props)
        this.state = {
            registeredTracks: [],
            tracks: [],
            genres: [],
            page: 1,
            genre: 1,
            lastPage: false,
            loading: false
        }
    }

    componentDidMount() {
        this.fetchTracks();
        this.fetchGenres();
        this.getAllTracks();
    }

    fetchGenres = async () => {
        const {data} = await getGenres();
        this.setState({genres: [{id: 0, name: 'Dope list'}, ...data.data,]})
    };

    getAllTracks = () => {
        const tracksRef = database().ref('/translation/tracks').orderByChild('order');
        tracksRef.on('value', (snapshot) => {
                const tracks = {};
                snapshot.forEach((item) => {
                    tracks[item.val().track_id] = item.val()
                });
                this.setState({registeredTracks: Object.values(tracks)})
            }
        )
    };


    fetchTracks = async () => {
        try {
            this.setState({loading: true})
            const {page, genre} = this.state;
            const {data} = await getTracks(genre, page);
            let lastPage = false
            if (!data.data.length) {
                lastPage = true
            }
            this.setState({tracks: this.state.tracks.concat(data.data), lastPage})
        } catch (e) {
            console.log(e)
        } finally {
            this.setState({loading: false})
        }
    };

    submitTrack = async (tracksToAdd) => {
        if (tracksToAdd.length) {
            tracksToAdd.map((track) => {
                if(this.state.genre === 0){
                    return Promise.all([
                        database()
                            .ref('/tracks/' + track.track_id)
                            .set(track),
                        database()
                            .ref('/translation/tracks/' + track.track_id)
                            .set(track)
                    ])
                }else{
                    const trackToSave = {
                        track_id: track.uuid,
                        artist_id: track.artist_uuid,
                        artist_name: track.artist_name,
                        track_name: track.name,
                        cover_art: track.cover_art,
                        media_id: track.media_id,
                        demo: track.demos[0]
                    }
                    return Promise.all([
                        database()
                            .ref('/tracks/' + track.uuid)
                            .set(trackToSave),
                        database()
                            .ref('/translation/tracks/' + track.uuid)
                            .set(trackToSave)
                    ])
                }

            })
        }
    }

    changeGenre = (e) => {
        const newGenre = e.target.value;
        let newTracks = this.state.tracks;
        if (newGenre !== this.state.genre) {
            newTracks = []
        }
        if (newGenre === 0) {
            newTracks = Object.values(seededTracks)
            this.setState({lastPage: false, genre: newGenre, tracks: newTracks, page: 1})
        } else {
            this.setState({lastPage: false, genre: newGenre, tracks: newTracks, page: 1}, () => {
                this.fetchTracks()
            })
        }

    };

    nextPage = () => {
        this.setState({page: this.state.page + 1},
            this.fetchTracks)
    };

    render() {
        const {tracks, genres, genre, page, registeredTracks, lastPage, loading} = this.state;
        return <AddTracksComponent
            changeGenre={this.changeGenre}
            loading={loading}
            tracks={tracks.filter(t => !registeredTracks.find(rt => rt.track_id === t.uuid ||rt.track_id ===  t.track_id))}
            genres={genres}
            genre={genre}
            page={page}
            submit={this.submitTrack}
            registeredTracks={registeredTracks}
            nextPage={this.nextPage}
            lastPage={lastPage}
        />
    }
}